/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {ContextNodeAutoSelect} from "../../../Components/Common/ContextNodeAutoSelect";
import React from "react";

export function ContextNodeFieldEditor(props) {
	
	const {FieldDef, RootData, OnUpdate, Value} = props;
	const {customData = {}} = FieldDef;
	const {contextNodeTypeId = null, orgIdField = null} = customData;
	
	//if this field is configured to be filtered by an org id lets do that.
	// but if we're looking at TFT we can ignore it.
	let orgId = null;
	if (orgIdField) {
		orgId = RootData[orgIdField];

		if (Number(orgId) === 1) {
			orgId = null;
		}
	}

	return <ContextNodeAutoSelect
		Value={Value != null ? Value : ""}
		userRoleId={RootData.userRoleId}
		OnUpdate={OnUpdate}
		OrganizationId={orgId}
		contextNodeTypeId={contextNodeTypeId}
		autoFocus={!Value}
	/>;
}
